<template>
    <div>
        <o-field label="Application Number *" :type="fieldType('application_number')" :message="getError('application_number')">
            <o-input placeholder="Application Number" v-model="form.application_number"/>
        </o-field>

        <o-field label="Location Of Work *" :type="fieldType('location_of_work')" :message="getError('location_of_work')">
            <o-input placeholder="Location of Work" v-model="form.location_of_work"/>
        </o-field>

        <o-field label="Applicant *" :type="fieldType('applicant_id')" :message="getError('applicant_id')">
            <o-select placeholder="Select an applicant" v-model="form.applicant_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="applicant in applicants"
                    :value="applicant.id"
                    :key="applicant.id">
                    {{ applicant.full_name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Permit Type *" :type="fieldType('permit_type_id')" :message="getError('permit_type_id')">
            <o-select placeholder="Select a Permit Type" v-model="form.permit_type_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="type in dotPermitTypes"
                    :value="type.id"
                    :key="type.id">
                    {{ type.title }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Expiration Date *" :type="fieldType('expiration_date')" :message="getError('expiration_date')">
            <Datepicker
                v-model="form.expiration_date"
                class="input"
                :config="{ enableTime: true }"
                placeholder="Pick a Date"/>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a status" v-model="form.status" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in dotPermitStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Area Of Work *" :type="fieldType('area_of_work')" :message="getError('area_of_work')">
            <o-input placeholder="Area of Work" v-model="form.area_of_work"/>
        </o-field>

        <o-field label="Street Frontage *" :type="fieldType('street_frontage')" :message="getError('street_frontage')">
            <o-input placeholder="Street Frontage" v-model="form.street_frontage"/>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import Datepicker from './../../../components/Datepicker'
    import { mapGetters } from 'vuex'

    export default  {
        mixins: [Application, HandlesForm],
        components: {
          Datepicker
        },

        data () {
            return {
                form: {
                    application_number: null,
                    location_of_work: null,
                    expiration_date: null,
                    street_frontage: null,
                    permit_type_id: null,
                    applicant_id: null,
                    area_of_work: null,
                    status: null
                }
            }
        },

        computed: {
            ...mapGetters({
                dotPermitStatuses: 'dotPermitStatuses',
                dotPermitTypes: 'dotPermitTypes',
                applicants: 'contacts'
            })
        }
    }
</script>
